import React, { useEffect, useMemo, useState } from 'react';
import SearchInput from '../../shared/components/SearchInput';
import Fuse from 'fuse.js';
import RESOURCE_FIELD_NAMES from '../constants/resourceFieldNames';
import { useShownResources } from '../ResourceStore';
import { useShallow } from 'zustand/shallow';

/**
 * @typedef {object} ResourcesSearchTabProps
 * @property {Array<*>} resources
 */

/**
 * @param {ResourcesSearchTabProps} props
 */
const ResourcesSearchTab = props => {
  const { resources } = props;

  const setShownResources = useShownResources(useShallow(state => state.setShownResources));

  const [searchValue, setSearchValue] = useState('');

  const shownResources = useMemo(() => {
    if (!searchValue) {
      return resources;
    }

    const fuse = new Fuse(resources, {
      keys: [
        RESOURCE_FIELD_NAMES.TAB,
        RESOURCE_FIELD_NAMES.TITLE,
        RESOURCE_FIELD_NAMES.DESCRIPTION
      ],
      findAllMatches: true,
      ignoreLocation: true,
      ignoreFieldNorm: true,
      threshold: 0.3
    });

    return fuse.search(searchValue).map(result => result.item);
  }, [resources, searchValue]);

  useEffect(() => {
    setShownResources(shownResources);
  }, [shownResources, setShownResources]);

  return (
    <>
      <div>
        <SearchInput onSearch={setSearchValue} />
      </div>
      <p className='results-count' data-testid='results-count'>
        Results: {shownResources.length}
      </p>
    </>
  );
};

export default ResourcesSearchTab;
